export function validationString(inputValue) {
    let isValid = true;
    let errors = {};

    const requiredFields = [
        "name",
        "nachname",
        "strabe",
        "location",
        "pLZ",
        "telephon",
        "power_consumption",
    ];

    requiredFields.forEach((field) => {
        if (!inputValue?.[field]?.trim?.()) {
            errors[field] = "Bitte überprüfe deine Eingabe";
            isValid = false;
        }
    });

    const selectFields = [
        "housetype",
        "satteldach",
        "roofFelt",
        "aktuellkeineAuto",
        "rooftype",
    ];

    selectFields.forEach((field) => {
        if (!inputValue?.[field]?.value?.trim?.()) {
            errors[field] = "Bitte überprüfe deine Eingabe";
            isValid = false;
        }
    });

    if (!inputValue?.schornstein?.length) {
        errors.schornstein = "Bitte überprüfe deine Eingabe";
        isValid = false;
    }

    return { isValid, errors };
}
